import {
  ApplicationType,
  GetApplicationDocument,
  GetApplicationQuery,
  GetApplicationQueryVariables,
  GetApplicationsDocument,
  useUpdateApplicationMutation,
} from "@/graphql/types";
import { QueryOptions } from "@apollo/client";
import gql from "graphql-tag";

gql`
  mutation UpdateApplication($input: UpdateApplicationInputType!) {
    updateApplication(input: $input) {
      ...ApplicationDetailsParts
    }
  }
`;

export default function useUpdateApplication() {
  const mutation = useUpdateApplicationMutation({});

  function call(application: ApplicationType) {
    mutation.mutate(
      {
        input: {
          applicationId: application.applicationId,
          name: application.name,
          emailContacts: application.emailContacts,
        },
      },
      {
        refetchQueries: [{ query: GetApplicationsDocument }],
        update: (cache) => {
          const parentQuery: QueryOptions<
            GetApplicationQueryVariables,
            GetApplicationQuery
          > = {
            query: GetApplicationDocument,
            variables: {
              applicationId: application.applicationId,
            },
          };
          cache.writeQuery({
            ...parentQuery,
            data: {
              application: {
                applicationId: application.applicationId,
                name: application.name,
              },
            },
          });
        },
      }
    );
  }
  return {
    ...mutation,
    call,
  };
}
